import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LibraryIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M12.53 1.152a1 1 0 0 0-1.06 0l-8 5A1 1 0 0 0 4 8h16a1 1 0 0 0 .53-1.848l-8-5ZM12 3.179 16.513 6H7.487L12 3.18Z"
        clipRule="evenodd"
      />
      <path d="M7 11a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0v-7ZM3 21a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Zm7-11a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1Zm5 1a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0v-7Zm3-1a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1Z" />
    </Icon>
  )
);
export default LibraryIcon;
